export function initValueDefaultDate(data, filterParam) {
  Dashboards.fireChange(filterParam, data.resultset[0][1]);
}
